module.exports = __webpack_public_path__ + "static/img/backgroundImage.1de890e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/industryApplication/backgroundImage.png
// module id = D0TU
// module chunks = 7